const ROTATION_INTERVAL = 60_000;
const LIST_SELECTOR = '[data-nisha-mega-products]';

/**
 * Rotates featured products across all desktop mega menus while preventing
 * the same product from appearing in two menus at the same time.
 */
class NishaMegaProductRotation {
  #rotationTimer;
  #observer;
  #scheduled = false;

  constructor() {
    this.rotate();

    this.#rotationTimer = window.setInterval(() => {
      if (!document.hidden) this.rotate();
    }, ROTATION_INTERVAL);

    this.#observer = new MutationObserver(() => this.scheduleRotation());
    this.#observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) this.rotate();
    });
  }

  scheduleRotation() {
    if (this.#scheduled) return;

    this.#scheduled = true;
    window.requestAnimationFrame(() => {
      this.#scheduled = false;
      this.rotate();
    });
  }

  rotate() {
    const lists = [...document.querySelectorAll(LIST_SELECTOR)];
    const usedProductIds = new Set();
    const timeSlot = Math.floor(Date.now() / ROTATION_INTERVAL);

    lists.forEach((list, listIndex) => {
      const items = [...list.querySelectorAll(':scope > [data-nisha-product-id]')];
      if (!items.length) return;

      const desktopCount = Math.max(1, Number.parseInt(list.dataset.nishaVisibleCount || '1', 10));
      const tabletCount = Math.max(1, Number.parseInt(list.dataset.nishaVisibleCountTablet || '1', 10));
      const offset = Number.parseInt(list.dataset.nishaRotationOffset || `${listIndex}`, 10);
      const start = (timeSlot * desktopCount + offset * desktopCount) % items.length;
      const selected = [];

      for (let step = 0; step < items.length && selected.length < desktopCount; step += 1) {
        const item = items[(start + step) % items.length];
        const productId = item.dataset.nishaProductId;

        if (!usedProductIds.has(productId)) {
          selected.push(item);
          usedProductIds.add(productId);
        }
      }

      items.forEach((item) => {
        item.hidden = !selected.includes(item);
        item.classList.remove('nisha-mega-product--entering');
      });

      selected.forEach((item, selectedIndex) => {
        item.classList.toggle('mega-menu__content-list-item--hidden-tablet', selectedIndex >= tabletCount);

        // Restart the small entrance animation whenever a new rotation appears.
        void item.offsetWidth;
        item.classList.add('nisha-mega-product--entering');
      });
    });
  }
}

const startRotation = () => {
  if (!window.nishaMegaProductRotation) {
    window.nishaMegaProductRotation = new NishaMegaProductRotation();
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startRotation, { once: true });
} else {
  startRotation();
}
